var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.082 62.9666H10.918C7.69793 62.9666 5.07812 60.3469 5.07812 57.1267V26.4016C5.07812 25.2798 5.98749 24.3703 7.10938 24.3703C8.23126 24.3703 9.14062 25.2798 9.14062 26.4016V57.1267C9.14062 58.1068 9.93789 58.9041 10.918 58.9041H54.082C55.0621 58.9041 55.8594 58.1068 55.8594 57.1267V26.4016C55.8594 25.2798 56.7687 24.3703 57.8906 24.3703C59.0125 24.3703 59.9219 25.2798 59.9219 26.4016V57.1267C59.9219 60.3468 57.3022 62.9666 54.082 62.9666Z",
    fill: "#88CCDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9687 33.5103C62.4489 33.5103 61.9291 33.312 61.5325 32.9153L36.2702 7.65325C34.1914 5.57427 30.8087 5.57427 28.7297 7.65325L3.46757 32.9154C2.67436 33.7087 1.3882 33.7087 0.594998 32.9154C-0.198333 32.1222 -0.198333 30.836 0.594998 30.0428L25.8572 4.78056C29.52 1.1177 35.4801 1.1177 39.1428 4.78056L64.4049 30.0427C65.1983 30.836 65.1983 32.1221 64.4049 32.9153C64.0085 33.312 63.4886 33.5103 62.9687 33.5103Z",
    fill: "#88CCDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.625 62.9666H24.375C23.2531 62.9666 22.3438 62.0571 22.3438 60.9354V42.908C22.3438 39.4079 25.1913 36.5604 28.6914 36.5604H36.3086C39.8087 36.5604 42.6562 39.4079 42.6562 42.908V60.9354C42.6562 62.0571 41.7469 62.9666 40.625 62.9666ZM26.4062 58.9041H38.5937V42.908C38.5937 41.648 37.5686 40.6229 36.3086 40.6229H28.6914C27.4314 40.6229 26.4062 41.648 26.4062 42.908V58.9041Z",
    fill: "#88CCDD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 65,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.a3cefda013c8505615c0e977c3e241aa.svg";
export { ForwardRef as ReactComponent };